import React from 'react';
import Button from 'screens/components/basic/Button';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import NumberInput from 'screens/components/basic/NumberInput';
import LOOKUP from 'constants/lookup';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "MonthlyProductSales";

const Header = (props) => (

    <CardSimple className="p-1">
        <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <NumberInput
                        name={componentName + LOOKUP.report.monthlyProductSales.year.name}
                        hintText={LOOKUP.report.monthlyProductSales.year.label}
                        label={LOOKUP.report.monthlyProductSales.year.label}
                        floatingLabelText={LOOKUP.report.monthlyProductSales.year.label}
                    />
                </div>
                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <BranchSelectAutoCompleteInput
                        name={componentName + LOOKUP.report.common.branchName}
                        fullWidth={true}
                        defaultValue={props.loggedBranch.toString()}
                        label={LOOKUP.report.common.branch}
                        floatingLabelText={LOOKUP.report.common.branch}
                        hintText={LOOKUP.report.common.branch}
                        options={props.branchOptions && props.branchOptions.length > 0 ? props.branchOptions : []}
                    />
                </div>
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.filter}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p className='purpleText'><b>Note: </b><strong className="blue-text"><i>The price is the price before discount and without tax.</i></strong></p>
            </div>
        </div>
    </CardSimple>
);

export default Header;
